import { useEffect } from 'react'
import { useRecentViewedProducts } from './useRecentViewedProducts'

const useSetProductOnRecentViewedProducts = (product: Product) => {
  const { addProductToRecentViewed } = useRecentViewedProducts();

  useEffect(() => {
    addProductToRecentViewed(product)
  }, [product])
}

export default useSetProductOnRecentViewedProducts
